<p-card styleClass="mb-3 custom-card-scope">
  <form [formGroup]="entryForm">
    <div class="flex gap-1 items-center">
      <p-floatlabel
        [ngClass]="isTimer ? 'w-[250px]' : 'w-[100px]'"
        variant="on"
      >
        <input
          #focus
          pInputText
          class="w-full custom-autocomplete"
          formControlName="ticketId"
          inputId="ticketId"
          [pAutoFocus]="true"
        />
        <label
          for="ticketId"
          [class.required-label]="fieldMeta.ticketId.required"
          >Ticket #</label
        >
      </p-floatlabel>

      <p-floatlabel variant="on">
        <div class="custom-select">
          <p-select
            [options]="userMetadata()?.projectMappingResponses"
            formControlName="projectId"
            optionLabel="projectName"
            optionValue="projectId"
            [ngClass]="isTimer ? 'w-[250px]' : 'w-[230px]'"
            inputId="project"
            [filter]="true"
            (onChange)="onProjectChange($event.value)"
          >
            <ng-template let-option pTemplate="item">
              <span class="text-xs whitespace-nowrap">
                <span class="font-semibold text-blue-custom">
                  {{ option.projectName?.split(' - ')[0] }}
                </span>
                <span class="font-medium text-client-red">
                  - {{ option.projectName?.split(' - ')[1] }}
                </span>
              </span>
            </ng-template>
          </p-select>
        </div>

        <label for="project" class="required-label">Project & Client</label>
      </p-floatlabel>

      <p-floatlabel variant="on">
        <p-select
          [options]="tasklist"
          optionValue="taskTypeId"
          optionLabel="taskTypeName"
          [ngClass]="'w-[200px]'"
          formControlName="taskTypeId"
          inputId="task"
          [filter]="true"
          (onChange)="onTaskChange($event.value)"
        />
        <label for="task" class="required-label">Task </label>
      </p-floatlabel>
      @if (!isTimer) {
        <p-floatlabel class="w-[160px]" variant="on">
          <p-datepicker
            formControlName="taskDate"
            [showIcon]="true"
            [showButtonBar]="false"
            [minDate]="minDate"
            [maxDate]="maxDate"
            (onSelect)="onDateSelect($event)"
            (onInput)="onTaskDate($event)"
            (onMonthChange)="onMonthChanged($event)"
            (onShow)="onCalOpen()"
          >
            <ng-template pTemplate="date" let-date>
              <span class="custom-day" [ngClass]="getHighlightClass(date)">
                {{ date.day }}
              </span>
            </ng-template>

            <ng-template pTemplate="footer">
              <div class="calendar-footer">
                <div class="calendar-footer-grid">
                  <div class="legend-item">
                    <span class="dot missingEntryColor"></span> &lt;
                    {{ userDetails()?.minHours | slice: 0 : 2 }}h
                  </div>
                  <div class="legend-item">
                    <span class="dot entryDoneColor"></span>
                    {{ userDetails()?.minHours | slice: 0 : 2 }}h &gt; - &lt;
                    {{ getOverTimeHour() }}h
                  </div>
                  <div class="legend-item ml-5">
                    <span class="dot overtimeColor"></span> &gt;
                    {{ getOverTimeHour() }}h
                  </div>
                  <div class="legend-item">
                    <span class="dot leaveColor"></span> Leave
                  </div>
                  <div class="legend-item">
                    <span class="dot holidayColor"></span> Holiday
                  </div>
                  <div class="legend-item ml-5">
                    <span class="dot weekendColor"></span> Weekend
                  </div>
                </div>
              </div>
            </ng-template> </p-datepicker
          ><label for="date" class="required-label">Date</label>
        </p-floatlabel>
      }
      <p-floatlabel
        [ngClass]="isTimer ? 'w-[500px]' : 'w-[280px]'"
        variant="on"
      >
        @if (IsTaskTypeMeeting) {
          <p-autocomplete
            [style]="{ width: '100%' }"
            [inputStyle]="{ width: '100%' }"
            optionLabel="subject"
            [suggestions]="filteredComments"
            formControlName="comment"
            (completeMethod)="filterComments($event)"
            (onSelect)="patchMeetingComment($event, false)"
          />
        } @else {
          <input
            class="w-full"
            type="text"
            pInputText
            formControlName="comment"
          />
        }
        <label for="comment" [class.required-label]="fieldMeta.comment.required"
          >Comment</label
        >
      </p-floatlabel>
      @if (!isTimer) {
        <p-floatlabel class="w-[110px]" variant="on">
          <p-datepicker
            formControlName="startTime"
            [timeOnly]="true"
            maxlength="5"
            panelStyleClass="hide-popup"
            inputId="startTime"
            (input)="
              onTimeInput(
                $event,
                entryForm.get('startTime')?.value,
                entryForm.get('endTime')?.value,
                false,
                null
              )
            "
            [showSeconds]="true"
            (onSelect)="
              calculateTimeDifference(
                entryForm.get('startTime')?.value,
                entryForm.get('endTime')?.value,
                true,
                null
              )
            "
            (onBlur)="timeBlur($event, true, false)"
          ></p-datepicker>
          <label
            for="startTime"
            class="required-label"
            [class.required-label]="fieldMeta.startTime.required"
            >Start Time</label
          >
        </p-floatlabel>

        <p-floatlabel class="w-[110px]" variant="on">
          <p-datepicker
            formControlName="endTime"
            [timeOnly]="true"
            inputId="endTime"
            maxlength="5"
            [showSeconds]="true"
            (onBlur)="timeBlur($event, false, false)"
            (input)="
              onTimeInput(
                $event,
                entryForm.get('startTime')?.value,
                entryForm.get('endTime')?.value,
                false,
                null
              )
            "
            (onSelect)="
              calculateTimeDifference(
                entryForm.get('startTime')?.value,
                entryForm.get('endTime')?.value,
                false,
                null
              )
            "
          />
          <label
            for="endTime"
            [class.required-label]="fieldMeta.endTime.required"
            >End Time</label
          >
        </p-floatlabel>
      }
      <p-floatlabel class="w-[100px]" variant="on">
        <input
          pInputText
          inputId="timeSpent"
          [style]="{ width: '100%' }"
          formControlName="timeSpent"
          (input)="onInput($event)"
          (blur)="onBlur(null)"
          maxlength="8"
        />

        <label
          for="timeSpent"
          [class.required-label]="fieldMeta.timeSpent.required"
          >Time</label
        >
      </p-floatlabel>

      @if (
        iconToggled &&
        (userDetails()?.timeCaptureScheme === 'TimeTicking' ||
          userDetails()?.timeCaptureScheme === 'Both')
      ) {
        <p-button
          [icon]="playIcon"
          (onClick)="timer()"
          [severity]="severityClockIcon"
          [pTooltip]="pTooltipClockIcon"
          tooltipPosition="bottom"
        />
        <p-button
          [pTooltip]="'Clear'"
          tooltipPosition="bottom"
          [icon]="PrimeIcons.TIMES"
          [outlined]="true"
          (onClick)="clearEntry(true, true)"
        ></p-button>
      }
      @if (
        CanAddTimeEntry &&
        (!isTimer || userDetails()?.timeCaptureScheme === 'Manual')
      ) {
        <p-button
          icon="pi pi-save"
          (onClick)="onSave()"
          [pTooltip]="'Save'"
          tooltipPosition="bottom"
          severity="primary"
        ></p-button>
        <p-button
          [icon]="PrimeIcons.TIMES"
          [outlined]="true"
          [pTooltip]="'Clear'"
          tooltipPosition="bottom"
          (onClick)="clearEntry(true, true)"
        ></p-button>
      }
      @if (userDetails()?.timeCaptureScheme === 'Both') {
        <p-button
          [disabled]="checkEntryButton()"
          [ngStyle]="{ padding: '10px 0px' }"
          [icon]="entryBtnIcon"
          [outlined]="iconToggled ? false : true"
          (onClick)="entryOption()"
          [pTooltip]="
            !((selectedTab === 1 || selectedTab === 2) && !isTimer)
              ? iconToggled
                ? 'Switch to Manual Entry'
                : 'Switch to Timer Entry'
              : ''
          "
          tooltipPosition="bottom"
          tabindex="-1"
        >
        </p-button>
      }
    </div>
    <!-- @if (fieldMeta.ticketId.required) {
      <div class="jira-comment-validation">
        Note: {{ TOAST_MESSAGES.jiraOrCommentValidatorMSG }}
      </div>
    } -->
  </form>
</p-card>
<p-toast />
<p-card styleClass="custom-card-scope">
  <div class="flex items-center gap-4 m-2 custom-progressbar">
    <span style="font-size: 0.8rem">
      Minimum Hours Required to Spend
      <span class="font-semibold">{{ minHoursStr }}</span>
    </span>
  </div>
  <div class="flex items-center gap-4 m-2 custom-progressbar">
    <p-progressbar
      [value]="progressValue"
      class="flex-1"
      [ngStyle]="{ '--p-progressbar-value-background': progressColor }"
    >
      <ng-template #content>
        <span class="colour" style="color: rgb(255, 255, 255)">{{
          timeDisplay
        }}</span>
      </ng-template>
    </p-progressbar>
    <!-- <h3 style="font-size: 1rem">
      Total Time Spent:
      <span class="font-semibold">{{ totalTimeSpent }}</span>
    </h3> -->
  </div>

  <div class="parent">
    <p-tabView
      class="custom-tabview"
      [(activeIndex)]="selectedTab"
      (onChange)="onTabChange()"
    >
      @for (tab of tabData; track tab.label) {
        <p-tabPanel [header]="tab.label">
          <div #tableWrapper class="editable-table-wrapper">
            <p-table
              #dt
              [value]="trackEntryTable"
              [paginator]="true"
              [columns]="columns"
              [paginator]="true"
              [rows]="10"
              [style]="{ width: '100%' }"
              [tableStyle]="{ 'table-layout': 'fixed', width: '100%' }"
              size="small"
              [(selection)]="selectedTrack"
              dataKey="id"
              stripedRows="true"
              appendTo="body"
              [rowsPerPageOptions]="[10, 50, 100, 200]"
              [globalFilterFields]="[
                'projectName',
                'endTime',
                'startTime',
                'taskName',
                'ticketId',
                'timeSpent',
                'comment',
                'taskDate',
              ]"
            >
              <ng-template #caption>
                <div
                  class="flex justify-between items-center w-full flex-wrap gap-2"
                >
                  <div class="flex items-center gap-2">
                    <p-button
                      *ngIf="CanDeleteTimeEntry"
                      icon="pi pi-trash"
                      label="Bulk Delete"
                      [disabled]="isTrackSelectionDisabled"
                      (onClick)="bulkDelete()"
                    ></p-button>
                    <p-button
                      icon="pi pi-user-edit"
                      label="Request Manager Approval"
                      (onClick)="reqApprovalOpen()"
                    ></p-button>
                  </div>
                  <div class="flex items-center gap-2 flex-wrap">
                    <p-button
                      icon="pi pi-download"
                      label="Export"
                      (onClick)="exportExcel(trackEntryTable)"
                    ></p-button>
                    <p-button
                      [icon]="
                        isAnyFilterApplied()
                          ? 'pi pi-filter-fill'
                          : 'pi pi-filter-slash'
                      "
                      label="Clear Filters"
                      [outlined]="true"
                      (onClick)="onClear(dt)"
                    ></p-button>

                    <p-iconfield iconPosition="left">
                      <p-inputicon>
                        <i class="pi pi-search"></i>
                      </p-inputicon>
                      <input
                        #searchInput
                        [(ngModel)]="searchText"
                        pInputText
                        type="text"
                        (input)="dt.filterGlobal(searchInput.value, 'contains')"
                        placeholder="Search Time Entries"
                      />
                    </p-iconfield>
                  </div>
                </div>
              </ng-template>

              <ng-template pTemplate="header" let-columns>
                <tr>
                  @for (item of columns; track $index) {
                    <th
                      [pSortableColumn]="item.field"
                      [style.width]="item.width"
                      [style.maxWidth]="item.width"
                      [style.minWidth]="item.width"
                      class="tblheader"
                    >
                      @if (item.type === 'selection') {
                        <div class="flex items-center justify-center gap-2">
                          <p-tableHeaderCheckbox />
                        </div>
                      }
                      <div class="flex items-center gap-2">
                        {{ item.header }}
                        @if (item.isFilterable) {
                          <p-columnFilter
                            [field]="item.field"
                            [type]="item.filterType"
                            [placeholder]="item.placeholder"
                            display="menu"
                          ></p-columnFilter>
                        }
                      </div>
                    </th>
                  }
                </tr>
              </ng-template>

              <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
                <tr [class.editing]="editingRow === rowData" tabindex="0">
                  @for (item of columns; track $index) {
                    <td
                      (click)="
                        item.editable &&
                          editingRow !== rowData &&
                          editTrack(rowData);
                        $event.stopPropagation()
                      "
                      class="whitespace-normal break-words"
                      [style.width]="item.width"
                      [style.maxWidth]="item.width"
                      [style.minWidth]="item.width"
                    >
                      <ng-container
                        *ngIf="
                          editingRow === rowData && item.editable;
                          else readOnly
                        "
                      >
                        <ng-container [ngSwitch]="item.type">
                          <input
                            *ngSwitchCase="'text'"
                            pInputText
                            [(ngModel)]="clonedRow[item.field]"
                            class="w-full"
                          />
                          <p-autocomplete
                            *ngSwitchCase="'autoComplete'"
                            [style]="{ width: '100%' }"
                            [inputStyle]="{ width: '100%' }"
                            optionLabel="subject"
                            [suggestions]="filteredComments"
                            [(ngModel)]="clonedRow[item.field]"
                            (completeMethod)="filterComments($event)"
                            (onSelect)="patchMeetingComment($event, false)"
                          />
                          <ng-container *ngSwitchCase="'dropdown'">
                            <p-select
                              *ngIf="item.header === 'Task'"
                              [options]="tasklistDropdown"
                              [(ngModel)]="clonedRow.taskTypeId"
                              optionLabel="taskTypeName"
                              optionValue="taskTypeId"
                              class="w-full"
                              appendTo="body"
                              [filter]="true"
                              (click)="$event.stopPropagation()"
                              (onShow)="onDropdownShow()"
                              (onHide)="onDropdownHide()"
                              (onChange)="
                                taskChange(clonedRow, $event.value, rowData)
                              "
                            ></p-select>

                            <p-select
                              *ngIf="item.header === 'Project & Client'"
                              [options]="
                                userMetadata()?.projectMappingResponses
                              "
                              [(ngModel)]="clonedRow.projectId"
                              optionLabel="projectName"
                              optionValue="projectId"
                              class="w-full"
                              appendTo="body"
                              [filter]="true"
                              (click)="$event.stopPropagation()"
                              (onShow)="onDropdownShow()"
                              (onHide)="onDropdownHide()"
                              (onChange)="
                                onProjectChange($event.value, true, clonedRow)
                              "
                            ></p-select>
                          </ng-container>
                          <!-- <p-select
                            *ngSwitchCase="'dropdown'"
                            [options]="
                              item.header === 'Task'
                                ? userMetadata()?.roleTaskMappingResponses
                                : userMetadata()?.projectMappingResponses
                            "
                            [ngModel]="
                              item.header === 'Task'
                                ? clonedRow.taskTypeId
                                : clonedRow.projectId
                            "
                            [optionLabel]="
                              item.header === 'Task'
                                ? 'taskTypeName'
                                : 'projectName'
                            "
                            [optionValue]="
                              item.header === 'Task'
                                ? 'taskTypeId'
                                : 'projectId'
                            "
                            class="w-full"
                            appendTo="body"
                            [filter]="true"
                            (click)="$event.stopPropagation()"
                            (onShow)="onDropdownShow()"
                            (onHide)="onDropdownHide()"
                            (onChange)="
                              item.header === 'Task'
                                ? taskChange(clonedRow, $event.value, rowData)
                                : onProjectChange($event.value, true, clonedRow)
                            "
                          ></p-select> -->
                          <div *ngSwitchCase="'timeRange'" class="flex gap-2">
                            <p-datepicker
                              [(ngModel)]="clonedRow.startTime"
                              [timeOnly]="true"
                              appendTo="body"
                              [showSeconds]="true"
                              (click)="$event.stopPropagation()"
                              (onBlur)="timeBlur($event, true, true, clonedRow)"
                              (input)="
                                onTimeInput(
                                  $event,
                                  clonedRow.startTime,
                                  clonedRow.endTime,
                                  true,
                                  clonedRow
                                )
                              "
                              (onSelect)="
                                calculateTimeDifference(
                                  clonedRow.startTime,
                                  clonedRow.endTime,
                                  true,
                                  clonedRow
                                )
                              "
                            ></p-datepicker>
                            <p-datepicker
                              [(ngModel)]="clonedRow.endTime"
                              [timeOnly]="true"
                              appendTo="body"
                              [showSeconds]="true"
                              (click)="$event.stopPropagation()"
                              (onBlur)="
                                timeBlur($event, false, true, clonedRow)
                              "
                              (input)="
                                onTimeInput(
                                  $event,
                                  clonedRow.startTime,
                                  clonedRow.endTime,
                                  true,
                                  clonedRow
                                )
                              "
                              (onSelect)="
                                calculateTimeDifference(
                                  clonedRow.startTime,
                                  clonedRow.endTime,
                                  true,
                                  clonedRow
                                )
                              "
                            ></p-datepicker>
                          </div>
                          <div *ngSwitchCase="'date'" class="flex gap-2">
                            <p-datepicker
                              [(ngModel)]="clonedRow[item.field]"
                              [ngModelOptions]="{ standalone: true }"
                              [iconDisplay]="'input'"
                              [showIcon]="true"
                              [minDate]="minDate"
                              [maxDate]="calMaxDate"
                              appendTo="body"
                              [monthNavigator]="true"
                              [yearNavigator]="true"
                              dateFormat="mm/dd/yy"
                              (onShow)="onDropdownShow()"
                              (onHide)="delayPopup()"
                              (onSelect)="delayPopup()"
                              (onBlur)="delayPopup()"
                            />
                          </div>
                          <div *ngSwitchCase="'timespent'" class="flex gap-2">
                            <input
                              pInputText
                              inputId="timeSpent"
                              [style]="{ width: '100%' }"
                              [(ngModel)]="clonedRow[item.field]"
                              (input)="onInput($event, true, clonedRow)"
                              (blur)="onBlur(clonedRow)"
                              maxlength="8"
                            />
                          </div>
                          <div *ngSwitchCase="'autoComplete'">
                            <p-autocomplete
                              [style]="{ width: '100%' }"
                              [inputStyle]="{ width: '100%' }"
                              appendTo="body"
                              optionLabel="subject"
                              [suggestions]="filteredComments"
                              [(ngModel)]="clonedRow[item.field]"
                              (completeMethod)="filterComments($event)"
                              (onSelect)="patchMeetingComment($event, true)"
                            />
                          </div>
                          <span *ngSwitchCase="'readonly'">
                            {{ clonedRow[item.field] || '-' }}
                          </span>
                        </ng-container>
                      </ng-container>

                      <ng-template #readOnly>
                        <!-- Selection Checkbox -->
                        <ng-container
                          *ngIf="item.type === 'selection'; else defaultDisplay"
                        >
                          <p-tableCheckbox
                            class="flex items-center justify-center gap-2"
                            [value]="rowData"
                          />
                        </ng-container>
                        <ng-template #defaultDisplay>
                          @if (item.type !== 'actions') {
                            <span
                              #textEl
                              [pTooltip]="
                                shouldShowTooltip ? rowData[item.field] : null
                              "
                              tabindex="0"
                              role="button"
                              tooltipPosition="top"
                              [style.maxWidth]="item.width"
                              class="cursor-pointer ellipsis-cell"
                              (keydown.enter)="
                                editTrack(rowData); $event.stopPropagation()
                              "
                              (mouseenter)="checkTooltipVisibility(textEl)"
                              (keydown.space)="
                                editTrack(rowData);
                                $event.preventDefault();
                                $event.stopPropagation()
                              "
                            >
                              @if (item.field === 'startTimeEndTime') {
                                {{
                                  rowData[item.field] || '00:00:00 - 00:00:00'
                                }}
                              } @else {
                                {{ rowData[item.field] || '-' }}
                              }
                            </span>
                          }
                        </ng-template>
                      </ng-template>

                      <!-- Actions -->
                      @if (item.type === 'actions') {
                        <span style="text-align: center">
                          @if (CanDeleteTimeEntry) {
                            <i
                              *ngIf="editingRow !== rowData"
                              class="pi pi-trash cursor-pointer ml-3"
                              tabindex="0"
                              pTooltip="Delete"
                              tooltipPosition="bottom"
                              role="button"
                              (click)="
                                confirmDelete(rowData); $event.stopPropagation()
                              "
                              (keydown.enter)="
                                confirmDelete(rowData); $event.stopPropagation()
                              "
                            ></i>
                          }

                          <i
                            *ngIf="editingRow !== rowData"
                            class="pi pi-clone cursor-pointer ml-3"
                            tabindex="0"
                            [pTooltip]="'Clone'"
                            tooltipPosition="bottom"
                            role="button"
                            (click)="
                              cloneTrack(rowData); $event.stopPropagation()
                            "
                            (keydown.enter)="
                              cloneTrack(rowData); $event.stopPropagation()
                            "
                          ></i>
                          <i
                            *ngIf="editingRow === rowData"
                            class="pi pi-save cursor-pointer ml-3"
                            tabindex="0"
                            [pTooltip]="'Update'"
                            tooltipPosition="bottom"
                            role="button"
                            (click)="
                              updateTrack(clonedRow); $event.stopPropagation()
                            "
                            (keydown.enter)="
                              updateTrack(clonedRow); $event.stopPropagation()
                            "
                          ></i>
                          <i
                            *ngIf="editingRow === rowData"
                            class="pi pi-times cursor-pointer ml-3"
                            [pTooltip]="'Cancel'"
                            tooltipPosition="bottom"
                            tabindex="0"
                            role="button"
                            (click)="
                              cancelEdit(rowData); $event.stopPropagation()
                            "
                            (keydown.enter)="
                              cancelEdit(rowData); $event.stopPropagation()
                            "
                          ></i>
                        </span>
                      }
                    </td>
                  }
                </tr>
              </ng-template>

              <ng-template #emptymessage>
                <tr>
                  <td colspan="9">No Entry found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </p-tabPanel>
      }
    </p-tabView>
  </div>
</p-card>
<p-toast />
<p-confirmdialog [draggable]="false" key="dialog" />
<p-confirmdialog
  key="overtimeDialog"
  class="overtimeDialog"
  [draggable]="false"
/>
<p-dialog
  header="Request Manager Approval"
  [(visible)]="isApprovalDialogVisible"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: '90%', height: '85%' }"
  (onHide)="reqApprovalClose()"
>
  <ng-template pTemplate="header">
    <h4>Request Manager Approval</h4>
  </ng-template>
  <ng-template pTemplate="content">
    <tw-req-timer-entry></tw-req-timer-entry>
  </ng-template>
  <ng-template pTemplate="footer"> </ng-template>
</p-dialog>
